const API_BASE = "/py";

function getAuthHeaders() {
  return {
    "Content-Type": "application/json",
  };
}

async function handleResponse(response, fallbackMessage) {
  if (!response.ok) {
    let errorMessage = fallbackMessage;

    try {
      const errorData = await response.json();
      if (errorData?.detail) {
        errorMessage = errorData.detail;
      } else if (errorData?.message) {
        errorMessage = errorData.message;
      }
    } catch (_) {}

    throw new Error(errorMessage);
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
}

export async function fetchNotifications() {
  const response = await fetch(`${API_BASE}/notifications`, {
    method: "GET",
    credentials: "include",
    headers: getAuthHeaders(),
  });

  return handleResponse(response, "Failed to load notifications");
}

export async function createNotification(data) {
  const response = await fetch(`${API_BASE}/notifications`, {
    method: "POST",
    credentials: "include",
    headers: getAuthHeaders(),
    body: JSON.stringify(data),
  });

  return handleResponse(response, "Failed to create notification");
}

export async function markNotificationAsRead(notificationId) {
  const response = await fetch(`${API_BASE}/notifications/${notificationId}/read`, {
    method: "PATCH",
    credentials: "include",
    headers: getAuthHeaders(),
  });

  return handleResponse(response, "Failed to mark notification as read");
}

export async function deleteNotification(notificationId) {
  const response = await fetch(`${API_BASE}/notifications/${notificationId}`, {
    method: "DELETE",
    credentials: "include",
    headers: getAuthHeaders(),
  });

  return handleResponse(response, "Failed to delete notification");
}